import axiosInstance from "./axiosInstance";

const labService = {
  create: async (payload) => {
    try {
      const response = await axiosInstance.post("/lab-test/create", payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  fetchAll: async () => {
    try {
      const response = await axiosInstance.get("/lab-test/all");
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  fetchCount: async () => {
    try {
      const response = await axiosInstance.get("/lab-test/count");
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  fetchById: async (id) => {
    try {
      const response = await axiosInstance.get(`/lab-test/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  update: async (id, payload) => {
    try {
      const response = await axiosInstance.put(`/lab-test/update/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/lab-test/delete/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default labService;
